import { RocketLaunch, PlayArrow } from "@mui/icons-material";
import React, { memo } from "react";
import { Box, Typography, Stack } from "@mui/material";

import { Handle } from "react-flow-renderer";

export default memo(({ data, isConnectable }) => {
  return (
    <Box
      sx={{
        backgroundColor: "rgba(34, 197, 94, 0.1)",
        backdropFilter: "blur(10px)",
        padding: "16px",
        borderRadius: "16px",
        border: "1px solid rgba(34, 197, 94, 0.3)",
        boxShadow: "0 10px 15px -3px rgba(34, 197, 94, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)",
        width: 260,
        position: "relative",
        transition: "all 0.3s ease",
        "&:hover": {
          backgroundColor: "rgba(34, 197, 94, 0.15)",
          borderColor: "rgba(34, 197, 94, 0.5)",
        }
      }}
      className="node-container"
    >
      <Stack direction="row" spacing={1.5} alignItems="center">
        <Box
          sx={{
            display: "flex",
            padding: "8px",
            borderRadius: "10px",
            background: "linear-gradient(135deg, #22c55e 0%, #16a34a 100%)",
            color: "#fff",
            boxShadow: "0 4px 12px rgba(34, 197, 94, 0.3)"
          }}
        >
          <RocketLaunch sx={{ fontSize: 20 }} />
        </Box>
        <Box>
          <Typography variant="subtitle2" sx={{ color: "#fff", fontWeight: 800, letterSpacing: "0.5px", lineHeight: 1.2 }}>
            INÍCIO
          </Typography>
          <Typography variant="caption" sx={{ color: "rgba(255,255,255,0.6)", fontWeight: 500 }}>
            Ponto de entrada do fluxo
          </Typography>
        </Box>
      </Stack>

      <Handle
        type="source"
        position="right"
        id="a"
        style={{
          background: "#22c55e",
          width: "14px",
          height: "14px",
          border: "2px solid #0B0F1C",
          right: "-8px",
          top: "50%",
        }}
        isConnectable={isConnectable}
      />
    </Box>
  );
});
